<template>
  <section class="page-section">
        <!-- filter -->
        <div class="filter-region">
          <div class="filter-form">
            <el-form size="small" :inline="true" :model="filterForm" ref="filterForm">
              <el-form-item label="年度：" prop="year">
                <el-date-picker v-model="filterForm.year" type="year" placeholder="选择年度"
                  value-format="yyyy">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="管家：" prop="serviceUserId">
                <el-select filterable v-model="filterForm.serviceUserId" placeholder="请选择">
                  <el-option v-for="item in serviceUser" :key="item.serviceUserId" :label="item.serviceUserName"
                    :value="item.serviceUserId"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-btn">
            <el-button-group class="btn-group">
              <el-button plain class="btn-reset" icon="el-icon-refresh"
                @click="filterFormReset('filterForm')"></el-button>
              <el-button type="primary" class="btn-search" @click="filterFormSubmit('filterForm')"
                :loading="tableLoading">查询</el-button>
            </el-button-group>
          </div>
        </div>
        <el-button class="btn-add-block" type="primary" @click="handleAdd">新增</el-button>
        <el-button class="btn-add-block" type="primary" @click="importDialogVisible = true">导入</el-button>

        <!-- table -->
        <list-table :table-data="tableData" :columns="tableColumns" :table-loading="tableLoading"
          :actions="tableActions" @action="handleAction" />

        <div class="table-footer">
          <div class="pagination-wrap">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :page-sizes="[20, 50, 100]" :pager-count="5" :current-page="page.current" :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper" :total="page.total">
            </el-pagination>
          </div>
        </div>

<import-dialog :visible.sync="importDialogVisible" @success="handleImportSuccess"></import-dialog>
<add-dialog :visible.sync="addDialogVisible" :dialog-mode="dialogMode" :row-data="currentRow" :service-user="serviceUser"
  @success="handleAddSuccess"></add-dialog>
      </section>
</template>

<script>
import ListTable from './components/list-table.vue'
import ImportDialog from './components/import-dialog.vue';
import AddDialog from './components/add-dialog.vue';
import { list,employeeAssessmentTargetList } from '@/common/api';

export default {
  name: 'PageName',
  components: { ListTable, ImportDialog, AddDialog },
  props: {},
  data() {
    return {
      filterForm: {
        serviceUserId: '',
        year: ''
      },
      serviceUser: [],
      tableLoading: false,
      tableData: [
        {
          name: '张三',
          annual: '2022年',
          serviceOrderTotalObjective: '100',
          productOrderTotalObjective: '100',
          month1: '10',
          month2: '10',
          month3: '10',
          month4: '10',
          month5: '10',
          month6: '10',
          month7: '10',
          month8: '10',
          month9: '10',
          month10: '10',
          month11: '10',
          month12: '10'
        }
      ],
      page: {
        current: 1,
        size: 20,
        total: 1
      },
      tableColumns: [
        { label: '员工姓名', prop: 'name', minWidth: '100' },
        { label: '考核年度', prop: 'annual', minWidth: '160' },
        { label: '服务单总目标', prop: 'serviceOrderTotalObjective', minWidth: '160' },
        { label: '商品订单总目标', prop: 'productOrderTotalObjective', minWidth: '100' },
        { label: '1月', prop: 'month1', minWidth: '80' },
        { label: '2月', prop: 'month2', minWidth: '80' },
        { label: '3月', prop: 'month3', minWidth: '80' },
        { label: '4月', prop: 'month4', minWidth: '80' },
        { label: '5月', prop: 'month5', minWidth: '80' },
        { label: '6月', prop: 'month6', minWidth: '80' },
        { label: '7月', prop: 'month7', minWidth: '80' },
        { label: '8月', prop: 'month8', minWidth: '80' },
        { label: '9月', prop: 'month9', minWidth: '80' },
        { label: '10月', prop: 'month10', minWidth: '80' },
        { label: '11月', prop: 'month11', minWidth: '80' },
        { label: '12月', prop: 'month12', minWidth: '80' }
      ],
      tableActions: [
        { label: '编辑', value: 'edit' },
        { label: '删除', value: 'delete' }
      ],
      importDialogVisible: false,
      addDialogVisible: false,
      dialogMode: 'add',
      currentRow: null
    }
  },
  computed: {},
  watch: {},
  created() { },
  mounted() {
    this.getAgentList();
    this.getList()
  },
  methods: {
    // 加载管家列表（给主页面顶部的管家筛选使用）
    getAgentList() {
      list().then(res => {
        if (res.code === 0 && res.data) {
          this.serviceUser = res.data;
        }
      }).catch(err => {
        console.error('getAgentList error:', err);
      });
    },
    // 加载目标列表
    getList() {
      const params = {
        employeeId: this.filterForm.serviceUserId,
        year: this.filterForm.year || '',
        pageNo: this.page.current,
        pageSize: this.page.size
      };
      this.tableLoading = true;
      console.log(params)
      employeeAssessmentTargetList(params).then(res => {
        console.log('getList res:', JSON.stringify(res))
        if (res.code === 0 && res.data) {
          this.tableData = (res.data.records || []).map(item => ({
            ...item,
            name: item.employeeName || '--',
            annual: item.year ? item.year + '年' : '',
            serviceOrderTotalObjective: item.serviceOrderTarget,
            productOrderTotalObjective: item.productOrderTarget
          }));
          this.page.total = res.data.total || 0;
        } else {
          this.$message.error((res && res.msg) || '获取目标列表失败');
        }
      }).catch(err => {
        console.error('getList error:', err);
        this.$message.error('获取目标列表发生错误');
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    handleAdd() {
      this.dialogMode = 'add';
      this.currentRow = null;
      this.addDialogVisible = true;
    },
    // 处理新增/编辑目标明细成功
    handleAddSuccess(formData) {
      this.getList();
    },
    handleAction(action, row) {
      console.log('handleAction', JSON.stringify(row))
      if (action === 'delete') {
        this.$confirm('确定要删除该业绩目标吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const index = this.tableData.indexOf(row);
          if (index > -1) {
            this.tableData.splice(index, 1);
            this.page.total -= 1;
            this.$message.success('删除成功');
          }
        }).catch(() => { });
      } else if (action === 'edit') {
        // 捕获表格内“编辑”点击动作
        this.dialogMode = 'edit';
        this.currentRow = row;
        this.addDialogVisible = true;
      }
    },
    filterFormSubmit() {
      this.page.current = 1;
      this.getList();
    },
    filterFormReset(formName) {
      this.$refs[formName] && this.$refs[formName].resetFields();
      this.page.current = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getList();
    },
    handleImportSuccess() {
      this.$refs.filterForm && this.$refs.filterForm.resetFields();
      this.page.current = 1;
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">
.page-main {
  padding-bottom: 60px;

  .page-section {
    .filter-region {
      display: flex;
      justify-content: space-between;

      .filter-form {
        flex: 1;
      }

      .filter-btn {
        .btn-group {
          .btn-reset {
            width: 40px;
            height: 40px;
            border-color: #3388ff;
            color: #3388ff;
          }

          .btn-search {
            width: 84px;
            height: 40px;
          }
        }

      }
    }
  }
}
</style>